import {Component, inject, Injector, OnInit} from "@angular/core";
import {BasicMaterialDialog} from "../../basic-material-dialog/basic-material-dialog.directive";
import {CreatePeerPracticeSessionDialogStateService} from "./service/create-peer-practice-session-dialog-state.service";
import {Translations} from "@translations";
import {SimSessionService} from "@services";
import {SessionDialogInput, SessionDialogOutput} from "@common/models/session-dialog";

@Component({
	selector: "sim-peer-practice-session-dialog",
	templateUrl: "./peer-practice-session-dialog.component.html",
	styleUrl: "./peer-practice-session-dialog.component.scss",
	providers: [CreatePeerPracticeSessionDialogStateService],
	standalone: false,
})
export class PeerPracticeSessionDialogComponent
	extends BasicMaterialDialog<PeerPracticeSessionDialogComponent, SessionDialogInput, SessionDialogOutput>
	implements OnInit
{
	// Properties
	public readonly T = Translations;
	public readonly stateService = inject(CreatePeerPracticeSessionDialogStateService);
	public readonly isLoading = this.stateService.isLoading;

	// Injections
	readonly #sessionService = inject(SimSessionService);

	constructor(injector: Injector) {
		super(injector);
	}

	async ngOnInit() {
		super.ngOnInit();
		await this.stateService.initState(this.data.eventDay, this.data.eventId, this.data.sessionId);
	}

	public async closeDialog(): Promise<void> {
		const sessionId = this.stateService.session()?.id;
		if (sessionId) {
			const outputSession = await this.#sessionService.getSessionById(sessionId);
			this.dialogRef.close({action: "ok", outputSession});
		} else {
			this.dialogRef.close({action: "cancel"});
		}
	}
}
